import React, {forwardRef, SVGProps} from 'react';
import styles from './styles.module.less';
import {join} from '@esgi/ui-kit/utils';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ArrowIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & {fill?: string}>(({fill = '#0077B8', direction, ...props}, ref) =>
	<svg {...props} xmlns='http://www.w3.org/2000/svg' width='13' height='9' viewBox='0 0 13 9' className={join(styles[direction], styles.icon)}>
		<path d='M11.2819 8.10498L6.69189 3.52498L2.10189 8.10498L0.691895 6.69498L6.69189 0.694981L12.6919 6.69498L11.2819 8.10498Z' fill={fill}/>
	</svg>);
